import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { BiologyProvider } from "../../../contexts/PlanOperationContext/Biology";
import { TabBiologyProvider } from '../../../contexts/PlanOperationContext/TabBiology';
import { selectTenant } from '../../../util/store/selectors';
import { INTEGRATION_MODE, KEY_STORAGE, KEY_TAB } from '../../../util/varibles/constants';
import Cancel from "./Cancel";
import Header from './Header';
import LocationsTab from './Locations';
import Planned from './Planned';
import ServiceRequest from './ServiceRequest';
import SmoltSite from './SmoltSite';
import Units from './Units';

export const isShowTab = (key: KEY_TAB, ids: Set<KEY_TAB>) => {
    if (key === KEY_TAB.LOCATIONS || key === KEY_TAB.SERVICE_REQUEST)
        return ids.has(key);
    return ids.size === 0 || ids.has(key)
}

const BiologyBrowser: React.FC = () => {
    const tenant = useSelector(selectTenant);
    const { planning_tabs = [] } = tenant;
    const { type = '' } = tenant?.integration || {};
    const ids = new Set(planning_tabs);

    useEffect(() => {
        localStorage.removeItem(KEY_STORAGE.UNITS_SELECTED);
    }, [])

    return <BiologyProvider>
        <Header />
        {isShowTab(KEY_TAB.PRODUCTION, ids) && <TabBiologyProvider>
            <Units />
        </TabBiologyProvider>}
        {isShowTab(KEY_TAB.LOCATIONS, ids) && <TabBiologyProvider>
            <LocationsTab />
        </TabBiologyProvider>}
        {isShowTab(KEY_TAB.SERVICE_REQUEST, ids) && <TabBiologyProvider>
            <ServiceRequest />
        </TabBiologyProvider>}
        {(type === INTEGRATION_MODE.STHP_FILE && isShowTab(KEY_TAB.HARVEST, ids)) && <TabBiologyProvider>
            <Planned />
        </TabBiologyProvider>}
        {isShowTab(KEY_TAB.SMOLT, ids) && <TabBiologyProvider>
            <SmoltSite />
        </TabBiologyProvider>}
        <Cancel />
    </BiologyProvider>
};

export default BiologyBrowser;
